<div class="overread-feedback-card">
  <div class="attribute-row">
    <form-factory [formGroup]="formGroup" [model]="overreadFeedbackEnabled"
                  (onChange)="onFeedbackToggle($event, 'overreadFeedbackEnabled', 'overreadFeedbackChallengeEnabled')"></form-factory>
  </div>
  <div class="overread-feedback-card__description secondary-text-color">Requires coders to review and acknowledge Overread I feedback.</div>
  <div class="overread-feedback-card__sub-settings">
    <div class="attribute-row">
      <form-factory [formGroup]="formGroup" [model]="requireOverreadFeedback"></form-factory>
      <div class="overread-feedback-card__hint">Turn on Overread I Feedback above to use this setting.</div>
    </div>
    <div *ngIf="!isHedisProject" class="attribute-row">
      <form-factory [formGroup]="formGroup" [model]="overreadFeedbackChallengeEnabled"></form-factory>
      <div class="overread-feedback-card__hint">Turn on Overread I Feedback above to use this setting.</div>
    </div>
  </div>
</div>

<div class="overread-feedback-card">
  <div class="attribute-row">
    <form-factory [formGroup]="formGroup" [model]="overread2FeedbackEnabled"
                  (onChange)="onFeedbackToggle($event, 'overread2FeedbackEnabled', 'overread2FeedbackChallengeEnabled')"></form-factory>
  </div>
  <div class="overread-feedback-card__description secondary-text-color">Requires coders to review and acknowledge Overread II feedback.</div>
  <div class="overread-feedback-card__sub-settings">
    <div class="attribute-row">
      <form-factory [formGroup]="formGroup" [model]="requireOverread2Feedback"></form-factory>
      <div class="overread-feedback-card__hint">Turn on Overread II Feedback above to use this setting.</div>
    </div>
    <div *ngIf="!isHedisProject" class="attribute-row">
      <form-factory [formGroup]="formGroup" [model]="overread2FeedbackChallengeEnabled"></form-factory>
      <div class="overread-feedback-card__hint">Turn on Overread II Feedback above to use this setting.</div>
    </div>
  </div>
</div>

<app-confirmation-modal [(visible)]="showTurnOffWarning"
                        header="WARNING"
                        (onCancel)="cancelTurnOff()"
                        acceptText="TURN OFF"
                        rejectText="CANCEL">
  Turning this off clears all pending acknowledgments and rebuttals within an hour. Continue?.
</app-confirmation-modal>
